import { render, staticRenderFns } from "./auditArticle.vue?vue&type=template&id=3da98dbc&"
import script from "./auditArticle.vue?vue&type=script&lang=ts&"
export * from "./auditArticle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports